import confetti from "canvas-confetti";
import { toast } from "sonner";

export const celebrateAwards = (awards) => {
  if (!awards) return;
  const gained = awards.xp_gained || 0;
  const badges = awards.new_badges || [];
  const quests = awards.quests_completed || [];

  if (gained > 0) {
    toast.success(`+${gained} XP kazandın! ✨`, { duration: 3500 });
  }
  badges.forEach((b) => {
    toast(`🏅 Yeni rozet: ${b.name}`, {
      description: b.desc,
      duration: 5000,
    });
  });
  quests.forEach((q) => {
    toast.success(`🎯 Görev tamam: ${q.title} (+${q.xp} XP)`, { duration: 4500 });
  });
  if (awards.level_up) {
    // Big confetti burst
    const end = Date.now() + 1200;
    const colors = ["#FFB703", "#1D3557", "#2A9D8F", "#E76F51", "#8ECAE6"];
    (function frame() {
      confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0 }, colors });
      confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1 }, colors });
      if (Date.now() < end) requestAnimationFrame(frame);
    })();
    toast(`🎉 Seviye atladın! Artık ${awards.level_after}. seviyedesin.`, { duration: 6000 });
  }
};
